import type { FieldValues, Path, Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import SwitchComponent from 'react-switch';

import { useUISettings } from 'contexts/index';

interface SwitchProps<T extends FieldValues> {
  control: Control<T>;
  registerName: Path<T>;
  label?: string;
  isDisabled?: boolean;
  onChange?: (checked: boolean, name: string) => void;
  className?: string;
}

export const Switch = <T extends FieldValues>({ label, control, registerName, isDisabled, onChange, className }: SwitchProps<T>) => {
  const { getColor } = useUISettings();
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Controller
        name={registerName}
        disabled={isDisabled}
        render={({ field }) => {
          const onChangeHandler = (checked: boolean) => {
            field.onChange(checked);
            onChange && onChange(checked, registerName as string);
          };

          return <SwitchComponent onColor={getColor('bg_secondary')} onChange={onChangeHandler} checked={!!field.value} disabled={isDisabled} />;
        }}
        control={control}
      />
      {label && (
        <label htmlFor={registerName} className="ml-2 text-sm">
          {label}
        </label>
      )}
    </div>
  );
};
